export default __webpack_public_path__ + "static/media/terraformcertifiedimg.78b1eba6.png";